$(document).ajaxComplete(function () {
  $(".search-flydown--product-items").each(function () {
    if ($(this).find(".rfq-btn").text() == "Request Quote") {
      $(this).find(".search-flydown--product-price ").hide();
    }
  });
  // Remove plus minus option if product have request a quote
  $(".productitem").each(function () {
    if ($(this).find(".rfq-btn").text() == "Request Quote") {
      $(this).find(".custom_pm").remove();
      $(this).find(".quickshop-button").remove();
    }
  });
});
/* Add to cart new functional */
$(document).on("click", ".add_to_cart_new", function () {
  $(this).addClass("processing");
  var variant_id = $(this).attr("data-variant-id");
  var tot_qty = $(this)
    .parent()
    .parent()
    .parent()
    .find(".product-price")
    .find("span")
    .attr("tot_qty");
  var pro_each_price = $(this)
    .parent()
    .parent()
    .parent()
    .find(".product-price")
    .find("span")
    .attr("each_price");
  var tot_qty_main = $(this)
    .parent()
    .parent()
    .parent()
    .find(".custom_pm")
    .find(".custom_qty")
    .val();
  //console.log("tot_qty_main"+ tot_qty_main);
  console.log(tot_qty);
  if (tot_qty_main == 0) tot_qty_main = 1;

  if (tot_qty == null || tot_qty == "undefined" || tot_qty == "") tot_qty = 1;

  if (
    $.isNumeric(variant_id) &&
    $.isNumeric(tot_qty) &&
    $.isNumeric(tot_qty_main)
  ) {
    var final_qty = tot_qty * tot_qty_main;
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { id: variant_id, quantity: final_qty },
      dataType: "json",
      success: function () {
        $(".productitem--action-atc").removeClass("processing");
        jQuery.getJSON("/cart.js", function (cart) {
          //console.log(cart);
          $("#shopify-section-static-header")
            .siblings(".atc-banner--container")
            .remove();
          $(".site-header-cart--count").attr(
            "data-header-cart-count",
            cart.item_count
          );
          // Custom mini cart
          let minicart = "";
          let pro_img = "";
          let pro_title = "";
          $(cart.items).each(function (index) {
            if (cart.items[index].id == variant_id) {
              pro_img = cart.items[index].image;
              pro_title = cart.items[index].product_title;
            }
          });
          minicart +=
            '<section class="atc-banner--container" data-animation-state="open"><div class="atc-banner--outer"><div class="atc-banner--inner"><div class="atc-banner--product">';
          minicart +=
            '<h2 class="atc-banner--product-title"><span class="atc-banner--product-title--icon">';
          minicart +=
            '<svg aria-hidden="true" focusable="false" role="presentation" width="18" height="13" viewBox="0 0 18 13" xmlns="http://www.w3.org/2000/svg">';
          minicart +=
            '<path fill="currentColor" fill-rule="evenodd" d="M6.23 9.1L2.078 5.2 0 7.15 6.23 13 18 1.95 15.923 0z"></path>';
          minicart += "</svg></span>Added to your cart:</h2>";
          minicart += '<div class="atc--product">';
          minicart +=
            '<div class="atc--product-image"><img src="' + pro_img + '"></div>';
          minicart +=
            '<div class="atc--product-details"><h2 class="atc--product-details--title">' +
            pro_title +
            "</h2>";
          minicart += '<span class="atc--product-details--price">';
          minicart +=
            '<span class="atc--product-details--price-quantity">' +
            final_qty +
            ' ×</span><span class="atc--product-details--price-value money"> $' +
            pro_each_price +
            "</span>";
          minicart += "</span></div></div></div>";
          minicart +=
            '<div class="atc-banner--cart"><div class="atc-banner--cart-subtotal"><span class="atc-subtotal--label">';
          minicart +=
            'Cart subtotal</span><span class="atc-subtotal--price money">$' +
            (cart.items_subtotal_price / 100).toFixed(2) +
            "</span></div>";
          minicart += '<footer class="atc-banner--cart-footer">';
          minicart +=
            '<a class="button-secondary atc-button--viewcart" href="/cart">View cart (<span>' +
            cart.item_count +
            "</span>)</a>";
          minicart +=
            '<form action="/cart" method="post" aria-label="cart checkout">';
          minicart +=
            '<button class="button-primary atc-button--checkout" type="submit" name="checkout" value="Checkout">Checkout</button>';
          minicart += "</form></footer></div></div>";
          minicart +=
            '<button class="atc-banner--close atc-close" type="button" aria-label="Close">';
          minicart +=
            '<svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">';
          minicart +=
            '<path fill="currentColor" fill-rule="evenodd" d="M5.306 6.5L0 1.194 1.194 0 6.5 5.306 11.806 0 13 1.194 7.694 6.5 13 11.806 11.806 13 6.5 7.694 1.194 13 0 11.806 5.306 6.5z"></path>';
          minicart += "</svg></button></div></section>";
          $("#shopify-section-static-header").after(minicart);
          closeMiniCart();
        });
      },
    });
  } else {
    return false;
  }
});
/* Custom quantity controller */
$(document).on("click", ".add", function () {
  if ($(this).prev().val() < 500000) {
    $(this)
      .prev()
      .val(+$(this).prev().val() + 1);
  }
});
$(document).on("click", ".sub", function () {
  if ($(this).next().val() > 1) {
    if ($(this).next().val() > 1)
      $(this)
        .next()
        .val(+$(this).next().val() - 1);
  }
});
// Close mini cart on click
function closeMiniCart() {
  $(".atc-close").click(function () {
    $(".atc-banner--container").remove();
  });
}
